import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { ImageContainer, Section, HeadingTwo, Button } from "../elements"
import {
  breakpointSmall,
  breakpointMedium,
  sectionAccentLight,
  sectionAccentMed,
  sectionAccentDark,
  textColorLight,
  breakpointLarge,
} from "../variables"
import styled from "styled-components"

const ImageWithTextSection = ({ slice }) => {
  const {
    image,
    image_placement,
    title,
    text_content,
    cta_link,
    cta_content,
    text_background_color,
  } = slice.primary

  const url = image.localFile.childImageSharp.fluid
  const [backgroundColor, setBackgroundColor] = useState(sectionAccentDark)
  const [ctaUrl, setCtaUrl] = useState()

  useEffect(() => {
    if (cta_link.url) {
      setCtaUrl(cta_link.url)
    }
    if (cta_link.slug) {
      setCtaUrl("/" + cta_link.slug)
    }
  }, [])

  useEffect(() => {
    if (text_background_color === "dark") {
      setBackgroundColor(sectionAccentDark)
    } else if (text_background_color === "medium") {
      setBackgroundColor(sectionAccentMed)
    } else if (text_background_color === "light") {
      setBackgroundColor(sectionAccentLight)
    } else {
      setBackgroundColor(sectionAccentDark)
    }
  }, [text_background_color])

  return (
    <SectionContainer
      heightMd="740px"
      width="100%"
      displayMd="grid"
      gtcMd={image_placement === "left" ? "1.5fr 1fr" : "1fr 1.5fr"}
      alignItems="center"
      imagePlacement={image_placement}
      backgroundColor={backgroundColor}
    >
      <div className="content-container">
        <HeadingTwo color={textColorLight}>{title.text}</HeadingTwo>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: text_content.html }}
        ></div>
        {ctaUrl && (
          <Link to={ctaUrl}>
            <Button>{cta_content.text}</Button>
          </Link>
        )}
      </div>
      <ImageContainer
        alt={image.alt}
        fluid={url}
        objectFit="cover"
        height="227px"
        heightMd="100%"
        width="100%"
      />
    </SectionContainer>
  )
}

export default ImageWithTextSection

const SectionContainer = styled(Section)`
  ${HeadingTwo} {
    max-width: 343px;
    font-size: 20px;
  }

  .content-container {
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: ${({ backgroundColor }) => backgroundColor};
    color: ${textColorLight};
    text-align: center;
    padding: 0px 20px;
    min-height: 322.96px;
    height: fit-content;

    .content {
      max-width: 456px;
      line-height: 1.56;
      font-size: 17px;
    }
  }

  @media (min-width: ${breakpointSmall}) {
    ${ImageContainer} {
      grid-column: ${({ imagePlacement }) =>
        imagePlacement === "left" ? 1 : 2};
      grid-row: 1;
    }

    .content-container {
      grid-column: ${({ imagePlacement }) =>
        imagePlacement === "left" ? 2 : 1};
      grid-row: 1;
      height: 100%;
    }

    ${HeadingTwo} {
      font-size: 22px;
    }
  }

  @media (min-width: ${breakpointLarge}) {
    ${HeadingTwo} {
      font-size: 22px;
      letter-spacing: 0.07em;
    }
  }
`
